export function isPastedFromExcel(html) {
  const excelRegex = /<meta.*?Microsoft Excel\s[\d].*?>/;
  return excelRegex.test(html);
}
